<template>
  <tooltip v-if="errorMessage" theme="error">
    <span class="error-underline" data-cy="error-content">
      <slot />
    </span>
    <template #content>
      <div class="flex flex-col gap-1">
        <span>{{ errorMessage }}</span>
        <span v-if="functionUsage" class="text-gray-300 text-xs">
          {{ $t("COMMON.USAGE") }}: '{{ functionUsage }}'
        </span>
      </div>
    </template>
  </tooltip>
  <slot v-else />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { EditorNodeName } from "@/enums/customAttributes";

import type { EditorNode } from "@/models/TextEditor";

interface ErrorNodeWrapperProps {
  node: EditorNode;
}

const { node } = defineProps<ErrorNodeWrapperProps>();
const { getters } = useStore();

const errorMessage = computed(() => node.error?.message ?? "");

const functionUsage = computed(() => {
  if (node.type !== EditorNodeName.function) {
    return "";
  }

  const functionLookupMap = getters["options/attributeFunctionsLookupMap"];
  return functionLookupMap.get(node.content.toLowerCase())?.usage ?? "";
});
</script>

<style scoped>
.error-underline {
  position: relative;
}

.error-underline::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  border-bottom: 1px dotted #ff595e;
  pointer-events: none;
}

.error-underline:hover::after {
  border-bottom: 2px dashed #ff595e;
}
</style>
